import React from "react";

const H3TipTap = ({ editor, height, width }) => {
  return (
    <svg
      className="cursor-pointer mr-15 pt-5"
      onClick={(e) => {
        e.preventDefault();

        editor.chain().focus().toggleHeading({ level: 3 }).run();
      }}
      width={width || "18"}
      height={height || "18"}
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill={
            editor.isActive("heading", { level: 3 }) ? "#4652b7" : "#807e7e"
          }
          d="M11.375 12.1875V0H8.66396V4.78729H2.69208V0H0V12.1875H2.69208V7.07131H8.66396V12.1875H11.375Z"
        />
        <path
          fill={
            editor.isActive("heading", { level: 3 }) ? "#4652b7" : "#807e7e"
          }
          d="M14.484 9.081H14.708C14.834 9.081 14.9577 9.07167 15.079 9.053C15.205 9.02967 15.3193 8.99 15.422 8.934C15.5247 8.878 15.6063 8.80333 15.667 8.71C15.7323 8.612 15.765 8.486 15.765 8.332C15.765 8.22 15.744 8.11967 15.702 8.031C15.66 7.94233 15.6017 7.86767 15.527 7.807C15.457 7.74633 15.373 7.69967 15.275 7.667C15.1817 7.63433 15.0837 7.618 14.981 7.618C14.7757 7.618 14.6053 7.67633 14.47 7.793C14.3347 7.90967 14.2413 8.06367 14.19 8.255L13.399 8.052C13.441 7.884 13.511 7.73233 13.609 7.597C13.7117 7.457 13.833 7.338 13.973 7.24C14.1177 7.13733 14.2787 7.058 14.456 7.002C14.6333 6.946 14.82 6.918 15.016 6.918C15.2307 6.918 15.4337 6.94833 15.625 7.009C15.821 7.065 15.9913 7.15133 16.136 7.268C16.2853 7.38 16.402 7.52 16.486 7.688C16.57 7.856 16.612 8.052 16.612 8.276C16.612 8.542 16.5303 8.78 16.367 8.99C16.2083 9.19533 15.9937 9.33067 15.723 9.396V9.41C16.0263 9.47067 16.2713 9.60833 16.458 9.823C16.6493 10.033 16.745 10.292 16.745 10.6C16.745 10.8567 16.6937 11.0807 16.591 11.272C16.493 11.4633 16.36 11.622 16.192 11.748C16.0287 11.874 15.8443 11.9673 15.639 12.028C15.4337 12.0933 15.226 12.126 15.016 12.126C14.806 12.126 14.6077 12.1027 14.421 12.056C14.2343 12.014 14.0617 11.9463 13.903 11.853C13.749 11.7597 13.6113 11.6383 13.49 11.489C13.3733 11.3397 13.2823 11.1623 13.217 10.957L14.001 10.712C14.0617 10.908 14.1737 11.0737 14.337 11.209C14.505 11.3443 14.722 11.412 14.988 11.412C15.0953 11.412 15.2027 11.398 15.31 11.37C15.422 11.3373 15.52 11.2883 15.604 11.223C15.6927 11.1577 15.7627 11.0737 15.814 10.971C15.87 10.8683 15.898 10.7423 15.898 10.593C15.898 10.4343 15.8583 10.3013 15.779 10.194C15.7043 10.082 15.6087 9.99567 15.492 9.935C15.3753 9.86967 15.2447 9.823 15.1 9.795C14.96 9.767 14.8247 9.753 14.694 9.753H14.484V9.081Z"
        />
      </g>
    </svg>
  );
};

export default H3TipTap;
